import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { HeaderComponent } from '../shared/header.component';

@Component({
  selector: 'oc-session-container',
  standalone: true,
  imports: [CommonModule, RouterModule, CdkTableModule, HeaderComponent],
  template: ` <router-outlet></router-outlet> `,
  styles: `
    
  `,
})
export class SessionContainerComponent {}
